export const HINT_KEY = 'mp_seen_hints_v1';
export const SHOWN_KEY = 'mp_shown_hints_v1';

// Artist page hints (shown in order). bell_artist only renders once the user
// follows (its target — the bell — doesn't exist before then), which makes it
// double as the "notifications are now a separate bell" announcement for
// users who followed before the follow/notification split.
export const ARTIST_HINTS = ['follow', 'bell_artist', 'share', 'track'];

// Track page hints (shown in order); bell_track behaves like bell_artist.
export const TRACK_HINTS = ['share_track', 'like', 'bell_track', 'notification'];

// Permanently dismissed — never show again
export const getSeenHints = () => {
    try { return JSON.parse(localStorage.getItem(HINT_KEY) || '[]'); }
    catch { return []; }
};
export const markHintSeen = (id) => {
    const s = getSeenHints();
    if (!s.includes(id)) localStorage.setItem(HINT_KEY, JSON.stringify([...s, id]));
};

// Auto-shown at least once — use beacon-only on subsequent visits
export const getShownHints = () => {
    try { return JSON.parse(localStorage.getItem(SHOWN_KEY) || '[]'); }
    catch { return []; }
};
export const markHintShown = (id) => {
    const s = getShownHints();
    if (!s.includes(id)) localStorage.setItem(SHOWN_KEY, JSON.stringify([...s, id]));
};

